import React, { useState, useEffect } from 'react';
import './OneToOneReview.css';
// import './createadmin.css';
import sortIcon from './images/sort.png';
import msortIcon from './images/msort.png';

const OneToOneReview = () => {
  const [oneToOneData, setOneToOneData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'ascending' });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const role = localStorage.getItem('role');
        const userId = localStorage.getItem('userId');

        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/onetoone`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();
        let filteredData = role === 'admin' ? data : data.filter((e) => e.userId === userId);

        setOneToOneData(filteredData);
        setFilteredData(filteredData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (searchQuery) {
      const lowercasedQuery = searchQuery.toLowerCase();
      const filtered = oneToOneData.filter(
        (entry) =>
          (entry.metWith && `${entry.metWith.firstName} ${entry.metWith.lastName}`.toLowerCase().includes(lowercasedQuery)) ||
          (entry.invitedBy && entry.invitedBy.toLowerCase().includes(lowercasedQuery))
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(oneToOneData);
    }
  }, [searchQuery, oneToOneData]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const sortData = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });

    const sortedData = [...filteredData].sort((a, b) => {
      let aValue, bValue;

      if (key === 'date') {
        aValue = a[key] ? new Date(a[key]) : new Date(0);
        bValue = b[key] ? new Date(b[key]) : new Date(0);
      } else if (key === 'metWith') {
        aValue = a.metWith ? `${a.metWith.firstName} ${a.metWith.lastName}`.toLowerCase() : '';
        bValue = b.metWith ? `${b.metWith.firstName} ${b.metWith.lastName}`.toLowerCase() : '';
      } else {
        aValue = a[key]?.toLowerCase() ?? '';
        bValue = b[key]?.toLowerCase() ?? '';
      }

      if (aValue < bValue) return direction === 'ascending' ? -1 : 1;
      if (aValue > bValue) return direction === 'ascending' ? 1 : -1;
      return 0;
    });

    setFilteredData(sortedData);
  };

  return (
    <div className="contain">
      <main className="main-content">
        <div className="table-containerOne">
          <h2 className='AddOneToOne'>View One-To-One</h2>

          <div className="search-containerOne">
            <input type="text" placeholder="Search by Met With or Invited By" value={searchQuery} onChange={handleSearch} />
          </div>


          {/* Desktop Table */}
          <table className="table-heading desktop-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th onClick={() => sortData('date')}>Date <img src={sortIcon} alt="Sort" className="sort-icon" /></th>
                <th onClick={() => sortData('metWith')}>Met With <img src={sortIcon} alt="Sort" className="sort-icon" /></th>
                <th onClick={() => sortData('invitedBy')}>Invited By <img src={sortIcon} alt="Sort" className="sort-icon" /></th>
                <th onClick={() => sortData('location')}>Location <img src={sortIcon} alt="Sort" className="sort-icon" /></th>
                <th onClick={() => sortData('topic')}>Topic <img src={sortIcon} alt="Sort" className="sort-icon" /></th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((entry, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{entry.date ? new Date(entry.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).replace(/ /g, '-') : 'Unknown'}</td>
                  <td>{entry.metWith ? `${entry.metWith.firstName} ${entry.metWith.lastName}` : 'Unknown'}</td>
                  <td>{entry.invitedBy ?? 'Unknown'}</td>
                  <td>{entry.location ?? 'No Location'}</td>
                  <td>{entry.topic ?? 'No Topic'}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Mobile Table */}
          {/* <div className="mobile-scroll-table"> */}
          <div className="mobile-scroll-table-add">
            <div className="mobile-scroll-wrapper">
              <table>
                <tbody>
                  <tr>
                    <th>S.No</th>
                    {filteredData.map((_, index) => (
                      <td key={`sno-${index}`}>{index + 1}</td>
                    ))}
                  </tr>
                  <tr>
                    <th onClick={() => sortData('date')}>Date <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {filteredData.map((entry, index) => (
                      <td key={`date-${index}`}>
                        {entry.date
                          ? new Date(entry.date).toLocaleDateString('en-GB', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric',
                          }).replace(/ /g, '-')
                          : 'Unknown'}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <th onClick={() => sortData('date')}>Met With <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {filteredData.map((entry, index) => (
                      <td key={`metwith-${index}`}>
                        {entry.metWith
                          ? `${entry.metWith.firstName} ${entry.metWith.lastName}`
                          : 'Unknown'}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <th onClick={() => sortData('date')}>Invited By <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {filteredData.map((entry, index) => (
                      <td key={`invitedby-${index}`}>{entry.invitedBy ?? 'Unknown'}</td>
                    ))}
                  </tr>
                  <tr>
                    <th onClick={() => sortData('date')}>Location <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {filteredData.map((entry, index) => (
                      <td key={`location-${index}`}>{entry.location ?? 'No Location'}</td>
                    ))}
                  </tr>
                  <tr>
                    <th onClick={() => sortData('date')}>Topic <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {filteredData.map((entry, index) => (
                      <td key={`topic-${index}`}>{entry.topic ?? 'No Topic'}</td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>


        </div>
      </main>
    </div>
  );
};

export default OneToOneReview;
